import IndexSortFilter from './index-sort-filter'
import '../mortgage-ga-dataLayer'
import '../mortgages/modal'

let indexSortFilter = new IndexSortFilter({
  listId: 'review-summary-list',
  loadMoreId: 'more-lenders',
  searchId: 'search-reviews-summary',
  itemSelector: '.review-summary-list-row',
  sorterSelector: '.lender-table__header-cell[data-sort]',
  classAscending: '--asc',
  classDescending: '--dsc',
  classActive: '--is-active',
  stateSelectId: 'select-state',
  perPage: 20
})
indexSortFilter.init()
